import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import uomAxios from '../../axios/uom'

export const fetchUom = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchUomStart())

    uomAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchUomSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchUomFailed(error))
      })
  }
}

export const fetchUomStart = () => {
  return {
    type: actionTypes.FETCH_UOM_START
  }
}

export const fetchUomSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_UOM_SUCCESS,
    pagination,
    records
  }
}

export const fetchUomFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_UOM_FAILED,
    errorMessage
  }
}

export const fetchUomById = recordId => {
  return dispatch => {
    dispatch(fetchUomStart())
    uomAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUomByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUomFailed(error))
      })
  }
}

export const fetchUomByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_UOM_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedUomRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_UOM_RECORD
  }
}

export const createUom = (recordData, page) => {
  return dispatch => {
    dispatch(createUomStart())

    uomAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'UOM Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createUomSuccess())
          dispatch(fetchUom(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid UOM field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createUomFailed())
      })
  }
}

export const createUomStart = () => {
  return {
    type: actionTypes.CREATE_UOM_START
  }
}

export const createUomSuccess = () => {
  return {
    type: actionTypes.CREATE_UOM_SUCCESS
  }
}

export const createUomFailed = () => {
  return {
    type: actionTypes.CREATE_UOM_FAILED
  }
}

export const updateUom = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateUomStart())

    uomAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'UOM Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateUomSuccess())
        dispatch(fetchUom(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid UOM field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateUomFailed())
      })
  }
}

export const updateUomStart = () => {
  return {
    type: actionTypes.UPDATE_UOM_START
  }
}

export const updateUomSuccess = () => {
  return {
    type: actionTypes.UPDATE_UOM_SUCCESS
  }
}

export const updateUomFailed = () => {
  return {
    type: actionTypes.UPDATE_UOM_FAILED
  }
}

export const deleteUom = (recordId, page) => {
  return dispatch => {
    dispatch(deleteUomStart())
    uomAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'UOM Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteUomSuccess())
        dispatch(fetchUom(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteUomFailed())
      })
  }
}

export const deleteUomStart = () => {
  return {
    type: actionTypes.DELETE_UOM_START
  }
}

export const deleteUomSuccess = () => {
  return {
    type: actionTypes.DELETE_UOM_SUCCESS
  }
}

export const deleteUomFailed = () => {
  return {
    type: actionTypes.DELETE_UOM_FAILED
  }
}

export const fetchUomFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchUomFilterCompanyStart())
    uomAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUomFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUomFilterCompanyFailed(error))
      })
  }
}

export const fetchUomFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_COMPANY_START
  }
}

export const fetchUomFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchUomFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchUomFilterUom = filter => {
  return dispatch => {
    dispatch(fetchUomFilterUomStart())
    uomAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUomFilterUomSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUomFilterUomFailed(error))
      })
  }
}

export const fetchUomFilterUomStart = () => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_UOM_START
  }
}

export const fetchUomFilterUomSuccess = data => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_UOM_SUCCESS,
    data
  }
}

export const fetchUomFilterUomFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_UOM_FILTER_UOM_FAILED,
    errorMessage
  }
}
